import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["section"]

  connect() {
    this.boundHandleSubmit = this.handleSubmit.bind(this)
    this.element.addEventListener("turbo:submit-end", this.boundHandleSubmit)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.boundHandleSubmit)
  }

  toggle() {
    if (!this.hasSectionTarget) return
    const section = this.sectionTarget
    const isHidden = section.classList.contains("post__comments--hidden")

    if (isHidden) {
      section.classList.remove("post__comments--hidden")
      const editor = section.querySelector("trix-editor")
      if (editor) setTimeout(() => editor.focus(), 100)
    } else {
      section.classList.add("post__comments--hidden")
    }
  }

  handleSubmit(event) {
    if (!event.detail.success) return

    const form = event.target
    if (!form.classList.contains("post-comment-form__form")) return

    if (this.hasSectionTarget) {
      this.sectionTarget.classList.remove("post__comments--hidden")
    }

    // Clear the Trix editor
    const editor = form.querySelector("trix-editor")
    if (editor && editor.editor) {
      editor.editor.loadHTML("")
    }
  }
}
